export const priceDisplay = (price) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  
    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
  });
  return formatter.format(Number(parseFloat(Math.round(price * 100) / 100)));
  //return '$' + parseFloat(Math.round(price * 100) / 100).toFixed(2);
}

export const discountedPriceDisplay = (price, discountPercent, discountAmount) => {
  let finalPriceToDisplay = '0';
  let finalPrice = 0;
  if (discountPercent > 0) {
    finalPrice = price - (price * discountPercent / 100);

  }
  else {
    finalPrice = parseFloat(price - discountAmount);
  }
  if (finalPrice < 0)
    finalPrice = 0;

  finalPriceToDisplay = '$' + parseFloat(finalPrice).toFixed(2);
  return finalPriceToDisplay;
}